import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
    { href: "#how-it-works", label: "Journey" },
    { href: "#genres", label: "Genres" },
    { href: "#lessons", label: "Costs" },
    { href: "#producers", label: "Producers" },
    { href: "#teachers", label: "Find your Partner" },
];

export default function Nav() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                scrolled
                    ? "backdrop-blur-xl bg-[#F1E8D5]/85 border-b-2 border-black"
                    : "bg-transparent"
            }`}
            data-testid="site-nav"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
                <a href="#top" className="flex items-center gap-2.5 text-[#C2410C]" data-testid="nav-logo">
                    <span className="flex gap-[3px] items-end h-5">
                        <span className="eq-bar" />
                        <span className="eq-bar" />
                        <span className="eq-bar" />
                        <span className="eq-bar" />
                        <span className="eq-bar" />
                    </span>
                    <span className="font-display text-[15px] tracking-tight font-bold uppercase text-black">
                        My First Single
                    </span>
                </a>

                <nav className="hidden md:flex items-center gap-9" data-testid="nav-links">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            className="link-underline text-sm text-black/80 hover:text-black"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <a
                    href="#teachers"
                    className="hidden md:inline-flex items-center gap-2 bg-[#C2410C] hover:bg-[#A8350A] text-white font-medium text-sm rounded-full px-5 py-2.5 transition-transform active:scale-95 border-2 border-black shadow-[3px_3px_0_0_#0A0A0A] hover:shadow-[1px_1px_0_0_#0A0A0A] hover:translate-x-[2px] hover:translate-y-[2px]"
                    data-testid="nav-cta"
                >
                    Start your journey
                </a>

                <button
                    className="md:hidden text-black p-2"
                    onClick={() => setOpen((s) => !s)}
                    aria-label="Toggle menu"
                    data-testid="nav-mobile-toggle"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {open && (
                <div className="md:hidden border-t-2 border-black bg-[#F1E8D5]/95 backdrop-blur-xl">
                    <div className="px-6 py-5 flex flex-col gap-4">
                        {links.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                onClick={() => setOpen(false)}
                                className="text-black text-base"
                            >
                                {l.label}
                            </a>
                        ))}
                        <a
                            href="#teachers"
                            onClick={() => setOpen(false)}
                            className="mt-2 inline-flex justify-center items-center bg-[#C2410C] text-white font-medium rounded-full px-5 py-3 border-2 border-black"
                        >
                            Start your journey
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
}
